import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import { store, history } from './redux/store';
import * as serviceWorker from './serviceWorker';


ReactDOM.render((
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/" component={App} />
            </Switch>
        </ConnectedRouter>
    </Provider>
)
    , document.getElementById('root')
);

serviceWorker.unregister();
